import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';
import { Navigate, useSearchParams } from 'react-router';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks';

export const Registration = () => {
  const [search] = useSearchParams();
  const { startRegistration } = useAuthFlow();
  const { ROUTE } = useRoute();

  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (!isAuthenticated) {
      startRegistration();
    }
  }, []);

  return <Navigate to={{ pathname: ROUTE.MAIN.path, search: search.toString() }} />;
};
